import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { setLanguage } from '@/utils/other';
import { getLocale } from '@/lang';

type ILogInfo = ILog.IResponse.ILogInfo;

export interface IAppState {
  sidebar: {
    opened: boolean;
  };
  menuDrawer: {
    visible: boolean;
  };
  logModal: {
    visible: boolean
    logs: ILogInfo[];
  };
  language: string;
}
@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
  public sidebar = {
    opened: true,
  };
  public menuDrawer = {
    visible: false,
  };
  public logModal = {
    visible: false,
    logs: [],
  };
  public language: string = getLocale();
  @Action
  public ToggleSideBar() {
    this.TOGGLE_SIDEBAR();
  }
  @Action
  public ToggleLogModal(logs?: ILog.IResponse.ILogInfo[]) {
    this.TOGGLE_LOG_MODAL();
    if (this.logModal.visible) {
      this.TOGGLE_LOG_MODAL_LOGS(logs || []);
    } else {
      this.TOGGLE_LOG_MODAL_LOGS([]);
    }
  }
  @Action
  public ToggleMenuDrawerVisible() {
    this.TOGGLE_MENU_VISIBLE();
  }
  @Action
  public SetLanguage(language: string) {
    this.SET_LANGUAGE(language);
  }
  @Mutation
  private TOGGLE_SIDEBAR() {
    this.sidebar.opened = !this.sidebar.opened;
  }
  @Mutation
  private TOGGLE_LOG_MODAL() {
    this.logModal.visible = !this.logModal.visible;
  }
  @Mutation
  private TOGGLE_LOG_MODAL_LOGS(logs: ILog.IResponse.ILogInfo[]) {
    (this.logModal.logs as ILogInfo[]) = logs;
  }
  @Mutation
  private TOGGLE_MENU_VISIBLE() {
    this.menuDrawer.visible = !this.menuDrawer.visible;
  }
  @Mutation
  private SET_LANGUAGE(language: string) {
    this.language = language;
    setLanguage(language);
  }
}
export const AppModule = getModule(App);
